// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zUR7F","right":"styles_right__31luu"};